export default "__VITE_ASSET__349c5b19__"